import { css as t, createGlobalStyle as o } from "styled-components";
import f from "./assets/f2f5d2264224e09d.woff2";
import r from "./assets/3253cc8d7999fed6.woff2";
import n from "./assets/281d70335c70144f.woff2";
import a from "./assets/ae2f669d6e70f4a2.woff2";
import l from "./assets/ad9cf607d41930e0.woff2";
import m from "./assets/4a0fbfc93756826e.woff2";
import i from "./assets/8ad16c60a00c9ee4.woff2";
import e from "./assets/7c5e5e2710ac7734.woff2";
import c from "./assets/58d3001f27548970.woff2";
import y from "./assets/ca802e041dcc2a29.woff2";
import s from "./assets/d996121e823ca9ed.woff";
import p from "./assets/9d9a81e0b6a12659.woff";
import w from "./assets/32f5e36bf9734e37.woff";
import I from "./assets/8f19ce801adbe1c1.woff";
import d from "./assets/641edf9ee87d40f7.woff";
import u from "./assets/01f3c70b541c0685.woff";
import F from "./assets/8e71f009dcc3bf1e.woff";
import g from "./assets/4f0a725523ed5040.woff";
import h from "./assets/4a468e48d95568e3.woff";
import k from "./assets/0b7b20af08b4ab7e.woff";
import $ from "./assets/0467b9a9c9097f96.woff";
import B from "./assets/43ce8a51ae3ee894.woff";
import b from "./assets/5f2857d8bac032dd.woff";
import S from "./assets/75f127c93d8d0682.woff";
import W from "./assets/2996cfe4e0ce7d9c.woff";
import R from "./assets/493102d520512ae3.woff";
import P from "./assets/c5c5fed6dd4c90d5.woff";
import x from "./assets/3d96da8893d52035.woff";
import L from "./assets/4ebf1ff9c506e9f3.woff2";
import T from "./assets/290547cf3c0c0f7c.woff2";
import E from "./assets/0b2c4ab1943344e0.woff2";
import M from "./assets/c80b74411450265c.woff2";
import C from "./assets/3119e9897691427d.woff2";
import G from "./assets/00945a0259e6aeb3.woff2";
import j from "./assets/76e8ca405dbaff5f.woff2";
import q from "./assets/0fc11d15abdecfa7.woff2";
import v from "./assets/e456b667e97c566a.woff2";
import z from "./assets/696373319061c3ea.woff2";
import A from "./assets/ff3f479158352c2d.woff2";
import D from "./assets/23abc2e2a794f85f.woff2";
import H from "./assets/805e90f7549e0da4.woff2";
import J from "./assets/97764223296cb55a.woff2";
import K from "./assets/3960bee164554a17.woff2";
import N from "./assets/d4b392f0e5ca5276.woff2";
import O from "./assets/04982a84df476265.woff2";
import Q from "./assets/cf1cd764bd35b80a.woff2";
import U from "./Brockmann-Bold.otf.mjs";
import V from "./Brockmann-SemiBold.otf.mjs";
import X from "./Brockmann-Medium.otf.mjs";
import Y from "./Brockmann-Regular.otf.mjs";
import Z from "./Brockmann-BoldItalic.otf.mjs";
import _ from "./Brockmann-SemiBoldItalic.otf.mjs";
import tt from "./Brockmann-MediumItalic.otf.mjs";
import ot from "./Brockmann-RegularItalic.otf.mjs";
const ft = t`
	@font-face {
		font-family: SF Pro;
		font-weight: 300;
		font-display: fallback;
		font-style: normal;
		src: url(${f}) format('woff2');
	}
	@font-face {
		font-family: SF Pro;
		font-weight: 400;
		font-display: fallback;
		font-style: normal;
		src: url(${l}) format('woff2');
	}
	@font-face {
		font-family: SF Pro;
		font-weight: 500;
		font-display: fallback;
		font-style: normal;
		src: url(${n}) format('woff2');
	}
	@font-face {
		font-family: SF Pro;
		font-weight: 600;
		font-display: fallback;
		font-style: normal;
		src: url(${a}) format('woff2');
	}
	@font-face {
		font-family: SF Pro;
		font-weight: 700;
		font-display: fallback;
		font-style: normal;
		src: url(${r}) format('woff2');
	}

	@font-face {
		font-family: SF Pro Rounded;
		font-weight: 300;
		font-display: fallback;
		font-style: normal;
		src: url(${m}) format('woff2');
	}
	@font-face {
		font-family: SF Pro Rounded;
		font-weight: 400;
		font-display: fallback;
		font-style: normal;
		src: url(${i}) format('woff2');
	}
	@font-face {
		font-family: SF Pro Rounded;
		font-weight: 500;
		font-display: fallback;
		font-style: normal;
		src: url(${e}) format('woff2');
	}
	@font-face {
		font-family: SF Pro Rounded;
		font-weight: 600;
		font-display: fallback;
		font-style: normal;
		src: url(${c}) format('woff2');
	}
	@font-face {
		font-family: SF Pro Rounded;
		font-weight: 700;
		font-display: fallback;
		font-style: normal;
		src: url(${y}) format('woff2');
	}

	//Inter weight 900
	@font-face {
		font-family: Inter;
		font-weight: 900;
		font-display: fallback;
		font-style: normal;
		src: url(${L}) format('woff2'),
			url(${s}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 900;
		font-display: fallback;
		font-style: italic;
		src: url(${T}) format('woff2'),
			url(${p}) format('woff');
	}

	//Inter weight 800
	@font-face {
		font-family: Inter;
		font-weight: 800;
		font-display: fallback;
		font-style: normal;
		src: url(${C}) format('woff2'),
			url(${d}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 800;
		font-display: fallback;
		font-style: italic;
		src: url(${G}) format('woff2'),
			url(${u}) format('woff');
	}

	//Inter weight 700
	@font-face {
		font-family: Inter;
		font-weight: 700;
		font-display: fallback;
		font-style: normal;
		src: url(${E}) format('woff2'),
			url(${w}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 700;
		font-display: fallback;
		font-style: italic;
		src: url(${M}) format('woff2'),
			url(${I}) format('woff');
	}

	//Inter weight 600
	@font-face {
		font-family: Inter;
		font-weight: 600;
		font-display: fallback;
		font-style: normal;
		src: url(${K}) format('woff2'),
			url(${W}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 600;
		font-display: fallback;
		font-style: italic;
		src: url(${N}) format('woff2'),
			url(${R}) format('woff');
	}

	//Inter weight 500
	@font-face {
		font-family: Inter;
		font-weight: 500;
		font-display: fallback;
		font-style: normal;
		src: url(${D}) format('woff2'),
			url(${B}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 500;
		font-display: fallback;
		font-style: italic;
		src: url(${H}) format('woff2'),
			url(${b}) format('woff');
	}

	//Inter weight 400
	@font-face {
		font-family: Inter;
		font-weight: 400;
		font-display: fallback;
		font-style: normal;
		src: url(${J}) format('woff2'),
			url(${S}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 400;
		font-display: fallback;
		font-style: italic;
		src: url(${v}) format('woff2'),
			url(${h}) format('woff');
	}

	//Inter weight 300
	@font-face {
		font-family: Inter;
		font-weight: 300;
		font-display: fallback;
		font-style: normal;
		src: url(${z}) format('woff2'),
			url(${k}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 300;
		font-display: fallback;
		font-style: italic;
		src: url(${A}) format('woff2'),
			url(${$}) format('woff');
	}

	//Inter weight 200
	@font-face {
		font-family: Inter;
		font-weight: 200;
		font-display: fallback;
		font-style: normal;
		src: url(${j}) format('woff2'),
			url(${F}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 200;
		font-display: fallback;
		font-style: italic;
		src: url(${q}) format('woff2'),
			url(${g}) format('woff');
	}

	//Inter weight 100
	@font-face {
		font-family: Inter;
		font-weight: 100;
		font-display: fallback;
		font-style: normal;
		src: url(${O}) format('woff2'),
			url(${P}) format('woff');
	}
	@font-face {
		font-family: Inter;
		font-weight: 100;
		font-display: fallback;
		font-style: italic;
		src: url(${Q}) format('woff2'),
			url(${x}) format('woff');
	}

	//Brockmann weight 700
	@font-face {
		font-family: Brockmann;
		font-weight: 700;
		font-display: fallback;
		font-style: normal;
		src: url(${U}) format('opentype');
	}
	@font-face {
		font-family: Brockmann;
		font-weight: 700;
		font-display: fallback;
		font-style: italic;
		src: url(${Z}) format('opentype');
	}

	//Brockmann weight 600
	@font-face {
		font-family: Brockmann;
		font-weight: 600;
		font-display: fallback;
		font-style: normal;
		src: url(${V}) format('opentype');
	}
	@font-face {
		font-family: Brockmann;
		font-weight: 600;
		font-display: fallback;
		font-style: italic;
		src: url(${_}) format('opentype');
	}

	//Brockmann weight 500
	@font-face {
		font-family: Brockmann;
		font-weight: 500;
		font-display: fallback;
		font-style: normal;
		src: url(${X}) format('opentype');
	}
	@font-face {
		font-family: Brockmann;
		font-weight: 500;
		font-display: fallback;
		font-style: italic;
		src: url(${tt}) format('opentype');
	}

	//Brockmann weight 400
	@font-face {
		font-family: Brockmann;
		font-weight: 400;
		font-display: fallback;
		font-style: normal;
		src: url(${Y}) format('opentype');
	}
	@font-face {
		font-family: Brockmann;
		font-weight: 400;
		font-display: fallback;
		font-style: italic;
		src: url(${ot}) format('opentype');
	}
`, no = o`
  ${ft}
`;
export {
  no as FontsStyles,
  ft as globalFontStylesCss
};
//# sourceMappingURL=fonts.mjs.map
